<template>
  <div>
    <van-nav-bar class="web-header base-header">
      <template #title>
        <span style="color: #fff">{{ $store.getters.getBaseInfo.name }}</span>
      </template>
      <template #left>
        <van-icon name="chat-o" color="#fff" size="24" @click="$router.push({name:'service'})" />
      </template>
    </van-nav-bar>
    <div class="view-page" style="padding-bottom: 50px">
      <div
        class="banners-box"
        v-for="(item, index) in basicData.banners"
        :key="index"
      >
        <img :src="item.url" />
      </div>
      <div class="girl-box">
        <div class="title">{{ $t("index.girl") }}</div>
        <div class="tj">
          <ul v-if="grillst">
            <li
              v-for="(item, index) in grillst.filter((x) => x.home == 1)"
              :key="index"
            >
              <div class="left">
                <div style="display: flex; flex-direction: column">
                  <img alt="" :src="item.img_url" />
                  <p style="margin-top: 6px">{{ item.yn_yu }}</p>
                </div>
                <span
                  ><i>{{ $t("index.advanced") }}</i></span
                >
              </div>
              <div class="right">
                <div class="title">
                  <span
                    ><span
                      class="van-badge__wrapper van-icon"
                      style="font-size: 13px"
                      ><img
                        class="van-icon__image"
                        src="../../assets/img/home/vipu.png"
                    /></span>
                    {{ $t("index.certification") }}</span
                  ><span
                    ><span
                      class="van-badge__wrapper van-icon"
                      style="font-size: 13px"
                      ><img
                        class="van-icon__image"
                        src="../../assets/img/home/vipu.png"
                    /></span>
                    {{ $t("index.authentication") }}</span
                  >
                </div>
                <div class="tips">
                  <span
                    v-for="(t, ti) in item.tag.split('#')"
                    :key="ti"
                    :style="!(t && t.length > 0) ? 'display:none' : ''"
                    >{{ t }}</span
                  >
                </div>
                <div class="sm">
                  <p class="sf">{{ $t("index.rating") }}:</p>
                  <div>
                    {{ item.title }}
                  </div>
                </div>
                <div class="btn" @click="profile(item.id)">{{ $t("index.apply") }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="account-box">
        <div class="title">
          {{ $t("index.accounttitle") }}
        </div>
        <div>
          <van-swipe :autoplay="3000" :show-indicators="false">
            <van-swipe-item v-for="(item,index) in account" :key="index">
              <div style="margin: 30px 0;text-align: center;color: #fff;">
                {{ $t('index.accountmsg',{name:item}) }}
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <FooterView />
    <div
      class="notice-bottom-popup"
      v-if="notice"
      :class="
        notice ? 'notice-slide-up-enter-active' : 'notice-slide-up-leave-active'
      "
    >
      <img
        src="../../assets/img/home/notice-img.png"
        class="notice-img"
        alt=""
      />
      <div class="notice-close-btn" @click="notice = null">
        <svg viewBox="0 0 24 24" width="18" height="18">
          <path
            fill="currentColor"
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          ></path>
        </svg>
      </div>
      <div class="notice-header">
        <span class="notice-title">{{ notice.title }}</span>
      </div>
      <div class="notice-content" v-html="notice.info"></div>
    </div>
  </div>
</template>

<script>
import FooterView from "@/components/Footer/index.vue";
export default {
  name: "HomeView",
  components: { FooterView },
  data() {
    return {
      basicData: {},
      notice: null,
      grillst: null,
      account: [],
    };
  },
  mounted() {
    this.getBasicConfig();
    this.getGirl();
    this.ranndAccount();
  },
  methods: {
    ranndAccount() {
      for (let i = 0; i < 345; i++) {
        this.account.push(
          this.generateRandomCode() + "****" + this.generateRandomCode()
        );
      }
    },
    generateRandomCode() {
      const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      let code = "";
      for (let i = 0; i < 2; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        code += chars[randomIndex].toLocaleLowerCase();
      }
      return code;
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData); //获取公告
      });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGirl() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
      }).then((res) => {
        this.grillst = res.data;
      });
    },
    profile(id) {
      this.$router.push({
        path:
          "/profile?id=" +
          id +
          "&name=" +
          this.vod_name +
          "&adsid=" +
          this.$route.query.id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.account-box {
  width: 96%;
  margin: 10px auto;
  border-radius: 10px;
  background: linear-gradient(180deg, #fe5986, #ff848b);
  .title {
    font-size: 16px;
    text-align: center;
    height: 38px;
    line-height: 38px;
    color: #ffe869;
  }
}
</style>
<style lang="scss" scoped>
.banners-box {
  width: 96%;
  margin: 10px auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
}
.girl-box {
  width: 96%;
  margin: 10px auto;
  .title {
    font-size: 16px;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss" scoped>
.tj ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  margin-bottom: 0.66667rem;
}
.tj ul li .right {
  flex: 1;
  padding-left: 0.66667rem;
}

.tj ul li .right .btn {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 0.26667rem;
  padding: 0.33333rem 0;
  width: 90%;
  margin: 0.33333rem 0 0.66667rem;
  text-align: center;
}

.tj ul li .right .title,
.tj ul li .right .title span {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.tj ul li .right .title span {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  margin-left: 0.2rem;
  padding: 0.16rem 0.4rem;
  font-size: 0.73333rem;
  border-radius: 0.46667rem 0;
  white-space: nowrap;
  max-width: 8rem;
  overflow: hidden;
}

.tj ul li .right .title p {
  padding-left: 0.66667rem;
  width: 40%;
  color: #000000d9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tj ul li .right .sm {
  text-align: left;
  color: #666;
  font-size: 0.8rem;
}

.tj ul li .right .sm > div {
  color: #999;
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 13.33333rem;
}

.tj ul li .right .sf {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0.33333rem;
}

.tj ul li .right .sf i,
.tj ul li .right .sf span {
  width: 1rem;
  height: 1rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABl0lEQVRIie3WMUhVURzH8c97WQg6VJIICeLUENIgDa+GmnSQCCKIHINqCkRoKWiwRVtcogjMzcVJHWrt4RBOWWu4iLW0NIRD8cjh3IeHy70+37vvbv7gDPd//ud+/3/O+f/Pqfz5eE8Heoo1fG93YbUD2CXM4XUHa9sGVvAOvZjA3bKBD3Aj+l5Ef1nAQbxK2YbxoizgIs5n2GdwudvASUznzJ0WDlClG8AqxvCmhd9NPMKpVsBKqg77cBXXUcM1nGv1k0i/sYlPqGMbjdihB7eTCGsYT2yd6ixuJSMOoJ4Esd2DAWHjy1AcwC/UqljGQknApvYT6E7z0DzHRkmwBu5ji8NT2jR+KwH4RJRMXBb7mMLPLsLm8TY2pOtwD3cSeFGt4FnamFX4W0IRF9Gm0Oj/HwcIXwoCP+Bv1kQecKggMKvJHwm8UBCY2w5PMszSrnAZH9Uk2gamM2xgXWgMo5jFFeGWWcW/lP9AHjDvKmpmuIslvJfdgerJuIjHeJisbXsPPzvM5mUOLNYP4TE1IjxFvuJMluMB65BGG6uhkFoAAAAASUVORK5CYII=)
    no-repeat 50%/100%;
}

.tj ul li .right .sf i {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABd0lEQVRIic3VX0tUQRjH8Y/LhoneRCKZWkQlIZKKN4qguG+i1+ilEAkSdFUhghdhN10sQimLCgmuiCCsFzsHj6dzlt3zB/rBwJln5nm+88yZZ2aovfNBDi2jib+DOtZywJ5gFZs5fHMBG6jjBWarBs5hJtZfx6OqgCMBENcYVqoCbuBxin0JT8sGvsS7HjEaZQGHMN5HwCm8D/N7qp7Sf4bnmAwtbRvT1MAaTvAHv3GGThLwGtMh+IR8pRJpGK9Cg5vkAuohg6UCkH4XcI2tGn5ivyJgpFts4yLavm+6d2MV6uATWtz/r8h4VgHwi1gy8QMSpd0uEbaPH3FD8kS28THAi+oXviaNaSXQwueCsBZ20wayau60ILApY5eygKMFgcNZA1nAfq+zLGX6/zcZjhQElprhJQ5wngeYfJ4iJTPs6J68Qxy5f3KmsIA3Hi5+YGCU4WWAHOIqZd5xaKO6D/B8+B4Y2MKeh9n00hW+B5+3WAyx/6nFOy/YRbaXhyhbAAAAAElFTkSuQmCC)
    no-repeat 50%/100%;
}

.tj ul li .right .tips {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.33333rem 0;
}

.tj ul li .right .tips span {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem 0.4rem;
  margin: 0.16667rem;
  color: #fff;
  border-radius: 0.33333rem;
  font-size: 0.76667rem;
}

.tj ul li .right .tips span:nth-child(n) {
  background: #fe257f;
}

.tj ul li .right .tips span:nth-child(2n) {
  background: #ff9702;
}

.tj ul li .right .tips span:nth-child(3n) {
  background: #0fa7fe;
}

.tj ul li .left {
  width: 6.93333rem;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 0.33333rem;
  position: relative;
  text-align: center;
}

.tj ul li .left span {
  position: absolute;
  transform: rotate(45deg);
  right: -5.66667rem;
  width: 6.66667rem;
  height: 6.66667rem;
  top: -3.33333rem;
  background: #ebcaaf;
  color: #8d684b;
  opacity: 0.9;
}

.tj ul li .left span i {
  position: absolute;
  font-weight: 600;
  left: 0.8rem;
  bottom: 0;
  font-size: 0.8rem;
}

.tj ul li .left img {
  width: 100%;
}
</style>
<style scoped>
.notice-bottom-popup {
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  box-shadow: 0 -4px 12px #00000026;
  z-index: 998;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #fe5986, #ff848b);
  border-radius: 10px;
  padding-bottom: 16px;
}

@media (min-width: 751px) {
  .notice-bottom-popup {
    max-width: 750px;
    left: 50%;
    right: auto;
    transform: translate(-50%);
    bottom: 56px;
    border-radius: 12px;
  }
}

@media (max-width: 750px) {
  .notice-bottom-popup {
    max-width: 750px;
    width: 100%;
    left: 50%;
    right: auto;
    transform: translate(-50%);
    bottom: 56px;
    border-radius: 12px;
    max-height: 250px;
  }
}

.notice-bottom-popup .notice-img {
  height: 90px;
  position: absolute;
  top: -90px;
  left: 20px;
  z-index: -1;
}

.notice-bottom-popup .notice-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #0000001a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
}

.notice-bottom-popup .notice-close-btn:hover {
  background: #0003;
  transform: rotate(90deg);
}

.notice-bottom-popup .notice-close-btn:active {
  transform: rotate(90deg) scale(0.9);
}

.notice-bottom-popup .notice-header {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.notice-bottom-popup .notice-icon {
  width: 22px;
  height: 22px;
  color: #fff;
  flex-shrink: 0;
}

.notice-bottom-popup .notice-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.3px;
}

.notice-bottom-popup .notice-content {
  max-height: 80px;
  overflow-y: auto;
  padding: 0 16px 16px;
  font-size: 14px;
  line-height: 1.2;
  color: #fff;
  text-align: left;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.notice-bottom-popup .notice-content::-webkit-scrollbar {
  width: 4px;
}

.notice-bottom-popup .notice-content::-webkit-scrollbar-track {
  background: transparent;
}

.notice-bottom-popup .notice-content::-webkit-scrollbar-thumb {
  background: #0003;
  border-radius: 2px;
}

.notice-bottom-popup .notice-content::-webkit-scrollbar-thumb:hover {
  background: #0000004d;
}

.notice-slide-up-enter-active {
  animation: slideUpIn-4659c500 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.notice-slide-up-leave-active {
  animation: slideDownOut-4659c500 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

@keyframes slideUpIn-4659c500 {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDownOut-4659c500 {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(100%);
    opacity: 0;
  }
}

@media (min-width: 751px) {
  .notice-slide-up-enter-active {
    animation: slideUpInPC-4659c500 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .notice-slide-up-leave-active {
    animation: slideDownOutPC-4659c500 0.3s
      cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  @keyframes slideUpInPC-4659c500 {
    0% {
      transform: translate(-50%) translateY(100%);
      opacity: 0;
    }

    to {
      transform: translate(-50%) translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideDownOutPC-4659c500 {
    0% {
      transform: translate(-50%) translateY(0);
      opacity: 1;
    }

    to {
      transform: translate(-50%) translateY(100%);
      opacity: 0;
    }
  }
}
</style>
